import { Component, Shark } from "shark-mvc";

import templateContent from "./priority-filter.html";

class PriorityFilterComponent extends Component {
	constructor () {
		super("priorityFilterComponent");
		this.addTemplate("", templateContent);
	}

	init () {
		
	}
}

const priorityFilterComponent = new PriorityFilterComponent();

Shark.registerComponent(priorityFilterComponent);

export default priorityFilterComponent;